import React from 'react';
import './CaseList.css';

const CaseList = ({ onCaseSelect }) => {
  const dummyCases = [
    { id: 1, title: 'Sample Case 1', status: 'OPEN' },
    { id: 2, title: 'Sample Case 2', status: 'IN_PROGRESS' },
  ];

  return (
    <div className="case-list">
      {dummyCases.map(caseItem => (
        <div 
          key={caseItem.id} 
          className="case-item"
          onClick={() => onCaseSelect(caseItem)}
        >
          <h3>{caseItem.title}</h3>
          <span className="case-status">{caseItem.status}</span>
        </div>
      ))}
    </div>
  );
};

export default CaseList; 